import React from 'react';
import { motion } from 'framer-motion';
import { GlassButton } from '../ui/GlassButton';
import { categories } from '../../data/jobs';
import type { Category } from '../../data/jobs';

interface CategoryFilterProps {
  selectedCategory: Category;
  onCategoryChange: (category: Category) => void;
}

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  selectedCategory,
  onCategoryChange
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8"
    >
      {categories.map((category, index) => (
        <motion.div
          key={category}
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, delay: 0.1 + index * 0.1 }}
        >
          <GlassButton
            active={selectedCategory === category}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </GlassButton>
        </motion.div>
      ))}
    </motion.div>
  );
}; 